export const SLACK_IMAGE =
  "https://yt3.ggpht.com/ytc/" +
  "AKedOLS2OOXtmIHu0Tf1TmWITVrHNktn" +
  "-MVXK3XRjwf4YA=s900-c-k-c0x00ffffff-no-rj";
